import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
export const getRecommendedHublet = () => {
  return noAuthApiClient.get('acquisition/v1/iplocation/hs-reg');
};